// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"452":"221d3ede","528":"130edd83","684":"975f7f7b","712":"930caf11","856":"7b94b3bb"}[chunkId] + ".css";
};